import React from 'react';
import {Link} from 'react-router-dom';
import './ServicesOverview.css';
import {services} from './Leistungen.js';
import serviceIcons from './serviceIcons';

// Weiche Trennstellen (U+00AD) für schmale Kacheln auf dem Handy. Sie sind
// unsichtbar, solange das Wort in eine Zeile passt.
const SHY = '­';
const hyphenated = {
  behandlungspflege: `Behand${SHY}lungs${SHY}pflege`,
  rufbereitschaft: `24h-Ruf${SHY}bereitschaft`,
  wundmanagement: `Wund${SHY}management`,
  palliativpflege: `Palliativ${SHY}pflege`,
  verhinderungspflege: `Verhin${SHY}derungs${SHY}pflege`,
  pflegeakademie: `Pflege${SHY}akademie`
};

/** Kompakte Leistungsübersicht für die Startseite: eine Kachel je Leistung. */
const ServicesOverview = () => (
  <section className="services-overview" id="leistungen" aria-labelledby="services-title">
    <div className="services-overview__inner">
      <div className="services-overview__head">
        <div>
          <p className="kicker">Leistungsübersicht</p>
          <h2 id="services-title">Unsere Leistungen im Überblick</h2>
        </div>
        <Link className="btn btn--ghost services-overview__more services-overview__more--desktop" to="/leistungen">
          Alle Leistungen ansehen
        </Link>
      </div>

      <ul className="services-overview__grid">
        {services.map((service) => (
          <li key={service.id}>
            <Link className="service-tile" to={`/leistungen/${service.id}`} aria-label={service.title}>
              <span className="service-tile__icon">{serviceIcons[service.id]}</span>
              <span className="service-tile__text">
                <strong>{hyphenated[service.id] || service.title}</strong>
                <span>{service.short}</span>
              </span>
              <span className="service-tile__arrow" aria-hidden="true">→</span>
            </Link>
          </li>
        ))}
      </ul>

      <Link className="btn btn--ghost services-overview__more services-overview__more--mobile" to="/leistungen">
        Alle Leistungen ansehen
      </Link>
    </div>
  </section>
);

export default ServicesOverview;
